import { ReactComponent as EmailPurple } from './icon_email_purple.svg';
import Icon, { IconProps } from './icon';

const IconEmailPurple = (props: IconProps) => {
  return <Icon {...props} Svg={EmailPurple} />;
};

export default IconEmailPurple;
